import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Header from "../../components/header/Header.js";
import Footer from "../../components/footer/Footer.js";
import TopButton from "../../components/topButton/TopButton.js";
import { publications } from "../../portfolio.js";
import "./ProjectDetails.css";
import { Fade } from "react-reveal";

class ProjectDetails extends Component {
  render() {
    const theme = this.props.theme;

    // Retrieve the project name from the route
    const projectName = this.props.match.params.projectname;

    // Find the project matching the route parameter
    const project = publications.data.find(
      (pub) => pub.id === projectName
    );

    // Handle case where no project matches the route parameter
    if (!project) {
      return (
        <div className="projects-main">
          <Header theme={theme} />
           {publications.data.length > 0 ? (
          <div className="basic-projects">
            <Fade bottom duration={2000} distance="40px">
              <div className="publications-heading-div">
                <div className="publications-heading-text-div">
                  <h1
                    className="publications-heading-text"
                    style={{ color: theme.text }}
                  >
                   {projectName }
                  </h1>
                  {/* <p
                    className="projects-header-detail-text subTitle"
                    style={{ color: theme.secondaryText }}
                  >
                   Am developing
                  </p> */}
                </div>
              </div>
            </Fade>
          </div>
        ) : null}
          <div className="no-project-message">
            <h2>Seriously... I don't remember working on such project. Check the project name very well</h2>
          </div>
          <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
          <TopButton theme={this.props.theme} />
        </div>
      );
    }

    return (
      <div className="projects-main">
        <Header theme={theme} />

        <div className="projects-heading-div">
          <h1>{project.name}</h1>
          <p>{project.description}</p>
          <a href={project.url} target="_blank" rel="noopener noreferrer" key={project.url}>
            Live Project
          </a>
        </div>

        <div className="repo-cards-div-main">
          {project.screenshots.map((screenshot, index) => (
              <div
                  className="publication-card-div"
                  style={{ backgroundColor: theme.highlight }}
                >
                  <Fade bottom duration={2000} distance="40px">
                    <div key={index}> 
                      <div className="publication-details">
                        <img className="publication-card-img" alt="screenshot"
                          src={require(`../../assests/images/projects/${project.folder}/${screenshot}`)}
                        />
                      </div>
                    </div>
                  </Fade>
                </div>
          ))}
        </div>

        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default withRouter(ProjectDetails);
